import Vue from 'vue'
import Router from 'vue-router'
import $store from '@/store'
import {readLocal} from '@/assets/js/common'
import assist from './modules/assist'
import personal from './modules/personal' // 个人类

Vue.use(Router)

// 页面刷新时 重新赋值
if (readLocal('userToken', 'token')) {
  $store.commit('setToken', readLocal('userToken', 'token'))
}

const createRouter = () => new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: '',
  routes: [
    ...assist
  ]
})

let syncRouters = userInfo => {
  return personal
}

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  // 非验证页面直接进入
  if (to.path.indexOf('/assist') >= 0) {
    if (to.matched.length === 0) {
      next('/assist/login')
    } else {
      next()
    }
  } else {
    // 如果不在路由表中时，判断用户信息是否有
    if (to.matched.length === 0) {
      // 判断是否存在token
      if ($store.state.base.token) {
        // 判断是否有用户信息
        if ($store.state.base.userInfo) {
          // 路径不对，去404
          next({
            path: '/error',
            replace: true
          })
        } else {
          $store.commit('setLoading', true)
          $store.dispatch('getUserInfo').then(res => {
            if (res === 'err') {
              next({
                path: '/assist/login',
                query: {
                  redirect: to.fullPath
                }
              })
            } else {
              // 重置已产生路由
              resetRouter()
              // 加入新路由
              router.addRoutes(syncRouters(res))
              next({...to, replace: true})
            }
          })
        }
      } else {
        next({
          path: '/assist/login',
          query: {
            redirect: to.fullPath
          }
        })
      }
    } else {
      // 判断是否需要权限
      if (to.matched.some(record => record.meta.requireAuth)) {
        if ($store.state.base.token) {
          if ($store.state.base.userInfo) {
            next()
          } else {
            $store.commit('setLoading', true)
            $store.dispatch('getUserInfo').then(res => {
              if (res === 'err') {
                next({
                  path: '/assist/login',
                  query: {
                    redirect: to.fullPath
                  }
                })
              } else {
                // 重置已产生路由
                resetRouter()
                // 加入新路由
                router.addRoutes(syncRouters(res))
                next({...to, replace: true})
              }
            })
          }
        } else {
          next({
            path: '/assist/login',
            query: {
              redirect: to.fullPath
            }
          })
        }
      } else {
        next()
      }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js